import type {z} from "zod";

import {EditMaterialNoteBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

const fields = EditMaterialNoteBody.shape;
export const editMaterialNoteFormSchema = zod.object({
  title: requiredStringSchema(fields.title, noteFieldLabelIds.title),
  content: requiredStringSchema(fields.content, noteFieldLabelIds.content),
});
export type EditMaterialNoteFormPayload = z.output<typeof editMaterialNoteFormSchema>;

export const draftEditMaterialNoteFormSchema = editMaterialNoteFormSchema.partial();
export type DraftEditMaterialNoteFormPayload = z.output<typeof draftEditMaterialNoteFormSchema>;
